import React, {useCallback, useState} from 'react';
import {Button, Col, Row} from 'reactstrap';

import Modal from 'components/Modal';
import useExitIntent from 'utils/useExitIntent.js';

export default function ModalExitScreening({children, ...props}) {
  const {isOpen, toggle} = useExitIntent(30000);
  return (
    <Modal className="modal-exit-intent modal-exit-intent-screening" isOpen={isOpen} toggle={toggle}>
      <Row className="text-center text-lg-left d-flex align-items-stretch m-0">
        <Col xs="12" lg="7" className="modal-exit-intent-copy order-lg-2 my-auto">
          <h4 className="section-heading mb-4">Did you know?</h4>
          <p className="mb-0">
            Most Alzheimer’s cases can be prevented with <br className="d-none d-sm-block d-md-none" />
            these 10 mighty brain breakthroughs.
          </p>
          <Button className="btn-exit text-uppercase text-white text-h6" color="cta" onClick={toggle} block>
            Keep watching <br className="d-none d-sm-block d-md-none" />
            and learn the TRUTH
          </Button>
        </Col>
        <Col xs="12" lg="5" className="exit-modal-image-col order-lg-1">
          <div className="exit-modal-image background-image-women-laughing" />
        </Col>
      </Row>
    </Modal>
  );
}
